import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStep, MatStepper, MatStepperNext, MatStepperPrevious } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';

import { InvoiceSetupService } from '../../services/invoice-setup.service';

@Component({
  selector: 'app-onboarding-wizard',
  standalone: true,
  imports: [
    MatStepper,
    MatStep,
    MatStepperNext,
    MatStepperPrevious,
    MatButton,
    MatIcon,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardContent,
    MatFormField,
    MatLabel,
    MatError,
    MatInput,
    ReactiveFormsModule,
  ],
  templateUrl: './onboarding-wizard.component.html',
  styleUrl: './onboarding-wizard.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingWizardComponent {
  private readonly _fb = inject(FormBuilder);
  private readonly _invoiceSetupService = inject(InvoiceSetupService);
  private readonly _router = inject(Router);
  private readonly _snackBar = inject(MatSnackBar);

  readonly isSubmitting = signal(false);

  readonly billingForm: FormGroup = this._fb.group({
    purchaseNumber: ['', [Validators.required, Validators.maxLength(100)]],
    invoiceEmail: ['', [Validators.required, Validators.email]],
  });

  submitOnboarding(): void {
    if (this.billingForm.invalid) {
      this.billingForm.markAllAsTouched();
      return;
    }

    this.isSubmitting.set(true);

    const val = this.billingForm.getRawValue();
    this._invoiceSetupService
      .submit({
        purchaseNumber: val.purchaseNumber.trim(),
        invoiceEmail: val.invoiceEmail.trim(),
      })
      .pipe(
        finalize(() => this.isSubmitting.set(false))
      )
      .subscribe({
        next: () => {
          this._snackBar.open('Facturatiegegevens succesvol opgeslagen.', 'Sluiten', {
            duration: 4000,
          });
          this._router.navigate(['/']);
        },
        error: () => {
          this._snackBar.open('Er is een fout opgetreden bij het opslaan van de gegevens.', 'Sluiten', {
            duration: 5000,
          });
        },
      });
  }
}
